// app/contexts/CookieConsentContext.tsx
//
// Lightweight context just to share the banner-visible flag between the
// CookieConsent component (which decides when to show) and the Layout
// (which needs to reserve room for it at the bottom of the page so the
// banner doesn't cover content).

import { createContext, useContext, useState, type ReactNode } from "react";

interface CookieConsentContextValue {
    isBannerVisible: boolean;
    setBannerVisible: (visible: boolean) => void;
}

const CookieConsentContext = createContext<CookieConsentContextValue | undefined>(undefined);

export const CookieConsentProvider = ({ children }: { children: ReactNode }) => {
    const [isBannerVisible, setBannerVisible] = useState(false);
    return (
        <CookieConsentContext.Provider value={{ isBannerVisible, setBannerVisible }}>
            {children}
        </CookieConsentContext.Provider>
    );
};

export const useCookieConsentBanner = () => {
    const ctx = useContext(CookieConsentContext);
    // Outside a provider (e.g. tests that don't wrap), default to "not
    // visible" — the layout will simply not add bottom padding.
    return ctx ?? { isBannerVisible: false, setBannerVisible: () => {} };
};
